import { Component, h, Host } from '@stencil/core';
import { theme } from '@eventstore-ui/theme';

/**
 * Displays Network illustration.
 * @part illustration - The root svg of the illustration.
 */
@Component({
    tag: 'es-illustration-network',
    styleUrl: 'network.css',
    shadow: true,
})
export class EsIllustrationNetwork {
    render() {
        const isDark = theme.isDark();

        return (
            <Host dark={isDark} light={!isDark}>
                {isDark ? this.renderDark() : this.renderLight()}
            </Host>
        );
    }

    renderLight() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 614.3 872.6"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <defs>
                    <linearGradient
                        id="network_b"
                        x1="236.1"
                        x2="262"
                        y1="476"
                        y2="520.9"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#fff" />
                        <stop offset="1" stop-color="#bbdefb" />
                    </linearGradient>
                    <linearGradient
                        id="network_c"
                        x1="467"
                        x2="491.9"
                        y1="647.6"
                        y2="690.7"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#fff" />
                        <stop offset="1" stop-color="#bbdefb" />
                    </linearGradient>
                    <linearGradient
                        id="network_d"
                        x1="341"
                        x2="366.5"
                        y1="159.1"
                        y2="203.2"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#fff" />
                        <stop offset="1" stop-color="#bbdefb" />
                    </linearGradient>
                </defs>
                <path
                    fill="#bbdefb"
                    fill-rule="evenodd"
                    d="m86.7 581.2 75.8 132.4 171.6-99.2c5.9-3.5 9.7-12.3 9.7-24.8v-114c0-8.6-1.5-17.2-4.6-25.2-4.4-11.9-252.5 130.8-252.5 130.8Z"
                />
                <path
                    fill="url(#network_b)"
                    fill-rule="evenodd"
                    d="m324.7 427.4-172.9 97.3 10.6 13.5 6.8 14 3.8 20.2 170.7-99.9c-.7-16.7-9.2-35.4-19-45Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M325.9 428.5c-1.8-1.9-3.9-3.5-6.2-4.8l-48.6-28.1-24.3-14-48.6-28.1c-5.2-3-9.9-3.2-13.9-1.2h-.3l-.7.4-170.8 98.9 26 45.4 85.9 45 201.5-113.5Z"
                />
                <path
                    fill="#bbdefb"
                    fill-rule="evenodd"
                    d="m354.1 733.6 76.5 134 170.5-98.5.7-.4h.2c5.7-3.7 9.3-12.4 9.3-24.5v-114c-.2-11.8-3.1-23.4-8.5-33.9-4.3-8.1-248.7 137.3-248.7 137.3Z"
                />
                <path
                    fill="url(#network_c)"
                    fill-rule="evenodd"
                    d="m608.6 611.1-19.3-31.6-244 138.4 24.7 43.3 240-144.9-1.2-5.1Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M590.2 580.2c-1-.8-2.1-1.6-3.2-2.2l-48.6-28.1-24.3-14-48.6-28.1c-5.4-3.1-10.3-3.2-14.4-.9L281 605.4l8.8 15.5 120 61.1 180.4-101.8Z"
                />
                <path
                    fill="#bbdefb"
                    fill-rule="evenodd"
                    d="M558.5 510.6 333.7 380.8v-95l-24.3-14v95L84.7 237c-1-.7-2.4-.8-3.5-.3l-17.7 9.8 15.2 12.6v2.8c0 5.2 2.7 11.1 6.1 13l42.3 24.5 42.6 35.4 2 96 10.5 15.8 18-10v-81.9l233.5 133.1 4 11 5.5 47.6V577l3.8 2.2 2.5 21.8 18-10v-81.9l14.2.7 63 48.7 17.3-9.6h.3c1.5-.9 2.4-3.1 2.4-6.2v-19c-.1-5.3-2.8-11.1-6.2-13.1Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="m437.3 476 103.2 51.1 21.9-12.1c-1.1-2-2.4-3.5-3.9-4.4L333.7 380.8l-18 10L437.3 476ZM298.9 360.7 84.7 237c-1-.7-2.4-.8-3.5-.3l-17.7 9.8 12.4 10.3 220.5 129.8 2.5-25.9Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M449.4 601v-95l91.1 52.6c3.4 1.9 6.1-.7 6.1-6v-19c0-5.2-2.7-11.1-6.1-13L315.7 390.8v-95l-24.3-14v95L66.7 247c-3.4-1.9-6.1.7-6.1 6v19c0 5.2 2.7 11.1 6.1 13l91.1 52.6v95l24.3 14v-95l243 140.3v95l24.3 14.1Z"
                />
                <path
                    fill="#1a4e85"
                    d="M126.2 279.6 81 253.5c-.4.9-.7 1.9-1.1 2.8l45.9 26.5c0-1.1.1-2.2.4-3.2ZM530.8 516.7c0-1.2-.2-2.4-.2-3.6L317.2 390v-95l-27.3-15.8v95l-143.4-82.9 2.8 5.1 143.7 83v-95l21.3 12.3v95l216.5 125ZM170.1 439.3c0-.4 0-.9.1-1.3l-10.9-6.3v-35.6c-1.1 0-2.1-.4-3-1v38.3l13.9 8c0-.7 0-1.4-.1-2.1ZM180.6 349v81.7c.8-.8 1.9-1.3 3-1.4v-75.1l118.3 68.3c0-.5.2-1.1.4-1.6 0-.5.3-.9.6-1.3L180.6 349ZM447.9 503.4v56c.4-.1.8-.2 1.2 0h1.8v-50.7l78.5 45.3.5-.5v-2.6l-82.1-47.4ZM445.2 596.8l-18.6-10.7v-20.5c-.8.4-1.6.7-2.5.7h-.5v21.5l18.3 10.6 3.3-1.6Z"
                />
                <path
                    fill="#bbdefb"
                    fill-rule="evenodd"
                    d="M489.8 142c-.2-11-2.7-21.8-7.5-31.7-4.3-9.1-258.9 136.4-258.9 136.4l85.2 133.1 169.1-97.9c1.6-.5 3.1-1.4 4.4-2.5l2.6-1.5-.5-.7c3.5-4.6 5.7-11.8 5.7-21.1V142h-.1Z"
                />
                <path
                    fill="url(#network_d)"
                    fill-rule="evenodd"
                    d="M466.6 90.3 213.9 232.5l27.8 42.8 247.1-144.7c-2.8-16.3-12.2-33.2-22.2-40.3Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="m467.7 91.4-2.2-1.4L319.7 5.8c-7.2-4.2-13.6-2.9-19.7 1.4l-167.4 97.7 16.7 26L285.1 194 467.7 91.4Z"
                />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="m100.1 494.6 48.6 28.1c13.4 7.7 24.3 31 24.3 52v114c0 21-10.9 31.7-24.3 24L27.2 642.5c-13.4-7.7-24.3-31-24.3-52v-114c0-21 10.9-31.7 24.3-24l48.6 28.1 24.3 14ZM367.4 649l48.6 28.1c13.4 7.7 24.3 31 24.3 52v114c0 21-10.9 31.7-24.3 24l-121.5-70.2c-13.4-7.7-24.3-31-24.3-52v-114c0-21 10.9-31.7 24.3-24l48.6 28.1 24.3 14ZM233.7 343.8l60.8 35.1c13.4 7.7 24.3-3 24.3-24v-114c0-21-10.9-44.3-24.3-52l-145.8-84.2c-13.4-7.7-24.3 3-24.3 24v114c0 21 10.9 44.3 24.3 52l60.8 35.1 24.2 14Z"
                />
                <path
                    fill="#1a4e85"
                    d="m210 138.4-53.9-31.1c-.2 1-.7 1.9-1.5 2.5h-.1l53.3 30.8 2.2-2.3ZM317.3 241v59.8l3-.9V241c0-21.4-11.2-45.3-25.1-53.3l-29.1-16.8-1.6 2.6 29.2 16.8c13 7.5 23.6 30.2 23.6 50.7ZM234.5 342.5l-85-49.1c-5.9-3.4-11.2-9.9-15.3-17.8l-2.7 1.2c4.4 8.6 10.2 15.6 16.5 19.3l145.7 84.1 1.5-2.6-60.7-35.1ZM171.5 574.7v85l3-.6v-84.4c0-21.4-11.2-45.3-25.1-53.3l-94.9-54.8-2.1 2.3 95.5 55.1c13 7.5 23.6 30.2 23.6 50.7ZM415.7 675.1l-109.6-63.3-1.5 2.6 108.6 62.7 2.5-2ZM441.8 830.3v-90.7l-3 .3v90.7c1-.2 2-.2 3-.3Z"
                />
                <path
                    fill="none"
                    stroke="#1a4e85"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="6"
                    d="m587 578-38-22 12.9-7.1h.3c1.5-.9 2.4-3.1 2.4-6.2v-19c0-5.2-2.7-11.1-6.1-13L333.7 380.8v-15.6l143.9-83.4c1.6-.5 3.1-1.4 4.4-2.5l2.6-1.5-.5-.7c3.5-4.6 5.7-11.8 5.7-21.1V142c0-21-10.9-44.3-24.3-52L319.7 5.8c-7.2-4.2-13-3.4-19 1L135 103.5c-.5.2-.9.5-1.3.8l-1 .6h.1c-5.1 4-8.3 12.4-8.3 23.8v114c.1 6.3 1 12.7 2.6 18.8l-42.4-24.4c-1-.7-2.4-.8-3.5-.3h0l-17.7 9.8h0c-1.7.7-2.8 3-2.8 6.4v19c0 5.2 2.7 11.1 6.1 13l91.1 52.6v30.1L12.8 451.6h-.1C6.8 455.2 3 464.1 3 476.5v114c0 21 10.9 44.3 24.3 52l121.5 70.2c5.9 3.4 11.4 3.2 15.6 0l105.9-61.2v93.3c0 21 10.9 44.3 24.3 52L416.1 867c5.9 3.4 11.3 3.2 15.6.2L601.1 769l.7-.4h.2c5.7-3.7 9.3-12.4 9.3-24.5v-114c0-21.1-10.9-44.4-24.3-52.2Zm-161.9-86v30.1l-81.1 47v-93.3c-.2-12.7-3.6-25.2-9.9-36.3l91 52.5Z"
                />
            </svg>
        );
    }

    renderDark() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 614.3 872.6"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <defs>
                    <linearGradient
                        id="network_b"
                        x1="236.1"
                        x2="262"
                        y1="476"
                        y2="520.9"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#ced4db" />
                        <stop offset="1" stop-color="#09264a" />
                    </linearGradient>
                    <linearGradient
                        id="network_c"
                        x1="467"
                        x2="491.9"
                        y1="647.6"
                        y2="690.7"
                        href="#network_b"
                    />
                    <linearGradient
                        id="network_d"
                        x1="341"
                        x2="366.5"
                        y1="159.1"
                        y2="203.2"
                        href="#network_b"
                    />
                </defs>
                <path
                    fill="#09264a"
                    fill-rule="evenodd"
                    d="m86.7 581.2 75.8 132.4 171.6-99.2c5.9-3.5 9.7-12.3 9.7-24.8v-114c0-8.6-1.5-17.2-4.6-25.2-4.4-11.9-252.5 130.8-252.5 130.8Z"
                />
                <path
                    fill="url(#network_b)"
                    fill-rule="evenodd"
                    d="m324.7 427.4-172.9 97.3 10.6 13.5 6.8 14 3.8 20.2 170.7-99.9c-.7-16.7-9.2-35.4-19-45Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="M325.9 428.5c-1.8-1.9-3.9-3.5-6.2-4.8l-48.6-28.1-24.3-14-48.6-28.1c-5.2-3-9.9-3.2-13.9-1.2h-.3l-.7.4-170.8 98.9 26 45.4 85.9 45 201.5-113.5Z"
                />
                <path
                    fill="#09264a"
                    fill-rule="evenodd"
                    d="m354.1 733.6 76.5 134 170.5-98.5.7-.4h.2c5.7-3.7 9.3-12.4 9.3-24.5v-114c-.2-11.8-3.1-23.4-8.5-33.9-4.3-8.1-248.7 137.3-248.7 137.3Z"
                />
                <path
                    fill="url(#network_c)"
                    fill-rule="evenodd"
                    d="m608.6 611.1-19.3-31.6-244 138.4 24.7 43.3 240-144.9-1.2-5.1Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="M590.2 580.2c-1-.8-2.1-1.6-3.2-2.2l-48.6-28.1-24.3-14-48.6-28.1c-5.4-3.1-10.3-3.2-14.4-.9L281 605.4l8.8 15.5 120 61.1 180.4-101.8Z"
                />
                <path
                    fill="#09264a"
                    fill-rule="evenodd"
                    d="M558.5 510.6 333.7 380.8v-95l-24.3-14v95L84.7 237c-1-.7-2.4-.8-3.5-.3l-17.7 9.8 15.2 12.6v2.8c0 5.2 2.7 11.1 6.1 13l42.3 24.5 42.6 35.4 2 96 10.5 15.8 18-10v-81.9l233.5 133.1 4 11 5.5 47.6V577l3.8 2.2 2.5 21.8 18-10v-81.9l14.2.7 63 48.7 17.3-9.6h.3c1.5-.9 2.4-3.1 2.4-6.2v-19c-.1-5.3-2.8-11.1-6.2-13.1Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="m437.3 476 103.2 51.1 21.9-12.1c-1.1-2-2.4-3.5-3.9-4.4L333.7 380.8l-18 10L437.3 476ZM298.9 360.7 84.7 237c-1-.7-2.4-.8-3.5-.3l-17.7 9.8 12.4 10.3 220.5 129.8 2.5-25.9Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="M449.4 601v-95l91.1 52.6c3.4 1.9 6.1-.7 6.1-6v-19c0-5.2-2.7-11.1-6.1-13L315.7 390.8v-95l-24.3-14v95L66.7 247c-3.4-1.9-6.1.7-6.1 6v19c0 5.2 2.7 11.1 6.1 13l91.1 52.6v95l24.3 14v-95l243 140.3v95l24.3 14.1Z"
                />
                <path
                    fill="#09264a"
                    d="M126.2 279.6 81 253.5c-.4.9-.7 1.9-1.1 2.8l45.9 26.5c0-1.1.1-2.2.4-3.2ZM530.8 516.7c0-1.2-.2-2.4-.2-3.6L317.2 390v-95l-27.3-15.8v95l-143.4-82.9 2.8 5.1 143.7 83v-95l21.3 12.3v95l216.5 125ZM170.1 439.3c0-.4 0-.9.1-1.3l-10.9-6.3v-35.6c-1.1 0-2.1-.4-3-1v38.3l13.9 8c0-.7 0-1.4-.1-2.1ZM180.6 349v81.7c.8-.8 1.9-1.3 3-1.4v-75.1l118.3 68.3c0-.5.2-1.1.4-1.6 0-.5.3-.9.6-1.3L180.6 349ZM447.9 503.4v56c.4-.1.8-.2 1.2 0h1.8v-50.7l78.5 45.3.5-.5v-2.6l-82.1-47.4ZM445.2 596.8l-18.6-10.7v-20.5c-.8.4-1.6.7-2.5.7h-.5v21.5l18.3 10.6 3.3-1.6Z"
                />
                <path
                    fill="#09264a"
                    fill-rule="evenodd"
                    d="M489.8 142c-.2-11-2.7-21.8-7.5-31.7-4.3-9.1-258.9 136.4-258.9 136.4l85.2 133.1 169.1-97.9c1.6-.5 3.1-1.4 4.4-2.5l2.6-1.5-.5-.7c3.5-4.6 5.7-11.8 5.7-21.1V142h-.1Z"
                />
                <path
                    fill="url(#network_d)"
                    fill-rule="evenodd"
                    d="M466.6 90.3 213.9 232.5l27.8 42.8 247.1-144.7c-2.8-16.3-12.2-33.2-22.2-40.3Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="m467.7 91.4-2.2-1.4L319.7 5.8c-7.2-4.2-13.6-2.9-19.7 1.4l-167.4 97.7 16.7 26L285.1 194 467.7 91.4Z"
                />
                <path
                    fill="#ced4db"
                    fill-rule="evenodd"
                    d="m100.1 494.6 48.6 28.1c13.4 7.7 24.3 31 24.3 52v114c0 21-10.9 31.7-24.3 24L27.2 642.5c-13.4-7.7-24.3-31-24.3-52v-114c0-21 10.9-31.7 24.3-24l48.6 28.1 24.3 14ZM367.4 649l48.6 28.1c13.4 7.7 24.3 31 24.3 52v114c0 21-10.9 31.7-24.3 24l-121.5-70.2c-13.4-7.7-24.3-31-24.3-52v-114c0-21 10.9-31.7 24.3-24l48.6 28.1 24.3 14ZM233.7 343.8l60.8 35.1c13.4 7.7 24.3-3 24.3-24v-114c0-21-10.9-44.3-24.3-52l-145.8-84.2c-13.4-7.7-24.3 3-24.3 24v114c0 21 10.9 44.3 24.3 52l60.8 35.1 24.2 14Z"
                />
                <path
                    fill="#09264a"
                    d="m210 138.4-53.9-31.1c-.2 1-.7 1.9-1.5 2.5h-.1l53.3 30.8 2.2-2.3ZM317.3 241v59.8l3-.9V241c0-21.4-11.2-45.3-25.1-53.3l-29.1-16.8-1.6 2.6 29.2 16.8c13 7.5 23.6 30.2 23.6 50.7ZM234.5 342.5l-85-49.1c-5.9-3.4-11.2-9.9-15.3-17.8l-2.7 1.2c4.4 8.6 10.2 15.6 16.5 19.3l145.7 84.1 1.5-2.6-60.7-35.1ZM171.5 574.7v85l3-.6v-84.4c0-21.4-11.2-45.3-25.1-53.3l-94.9-54.8-2.1 2.3 95.5 55.1c13 7.5 23.6 30.2 23.6 50.7ZM415.7 675.1l-109.6-63.3-1.5 2.6 108.6 62.7 2.5-2ZM441.8 830.3v-90.7l-3 .3v90.7c1-.2 2-.2 3-.3Z"
                />
                <path
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="6"
                    d="m587 578-38-22 12.9-7.1h.3c1.5-.9 2.4-3.1 2.4-6.2v-19c0-5.2-2.7-11.1-6.1-13L333.7 380.8v-15.6l143.9-83.4c1.6-.5 3.1-1.4 4.4-2.5l2.6-1.5-.5-.7c3.5-4.6 5.7-11.8 5.7-21.1V142c0-21-10.9-44.3-24.3-52L319.7 5.8c-7.2-4.2-13-3.4-19 1L135 103.5c-.5.2-.9.5-1.3.8l-1 .6h.1c-5.1 4-8.3 12.4-8.3 23.8v114c.1 6.3 1 12.7 2.6 18.8l-42.4-24.4c-1-.7-2.4-.8-3.5-.3h0l-17.7 9.8h0c-1.7.7-2.8 3-2.8 6.4v19c0 5.2 2.7 11.1 6.1 13l91.1 52.6v30.1L12.8 451.6h-.1C6.8 455.2 3 464.1 3 476.5v114c0 21 10.9 44.3 24.3 52l121.5 70.2c5.9 3.4 11.4 3.2 15.6 0l105.9-61.2v93.3c0 21 10.9 44.3 24.3 52L416.1 867c5.9 3.4 11.3 3.2 15.6.2L601.1 769l.7-.4h.2c5.7-3.7 9.3-12.4 9.3-24.5v-114c0-21.1-10.9-44.4-24.3-52.2Zm-161.9-86v30.1l-81.1 47v-93.3c-.2-12.7-3.6-25.2-9.9-36.3l91 52.5Z"
                />
            </svg>
        );
    }
}
